export default __webpack_public_path__ + "static/media/gummy@3x.61036fa2.png";